import styled from 'styled-components';

const FooterStyles = styled.footer`
  background: ${props => props.theme.primaryDark};
  padding: 30px 0;
  padding-bottom: 0;
  color: #fff;

  .header-title {
    color: #fff;
    font-size: 0.875rem;
    font-weight: 500;
    text-transform: uppercase;
    margin: -0.25rem 0 0 0;
  }

  a {
    color: #fff;
    border-radius: 10px;
    transition: all 0.2s;
    &:hover {
      text-decoration: underline;
    }
  }

  p {
    font-size: 0.8125rem;
    color: ${props => props.theme.gray500};
    margin-bottom: 0rem;
    width: 100%;
    font-size: 11px;
  }

  .footer-icons {
    max-width: 300px;
    margin auto;

    ${props => props.theme.media.lg} {
      margin-top: 0px;
    }
  }
  .connection-container.mobile {
    display: block;
  }
  .connection-container.desktop {
    display: none;
  }
  .container {
    max-width: 100%;
  }

  .footer-main {
    display: grid;
    max-width: 320px;
    margin: auto;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-gap: 15px;
    position: relative;
  }

  .footer-left {
    margin-bottom 40px;

    & .logo-img {
      width: 116px;
      max-width: 116px;
      height: 25.9667px;
      max-height:  25.9667px;
    }
  }

  .connection-container {
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    font-size: 13px;

    a {
      text-decoration: none;
    }
  }

  .footer-middle {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    margin-top: 30px;

    ${props => props.theme.media.lg} {
      margin-top: 0px;
    }


    .company {
      grid-column: 2;
    }

    .subsection {
      margin-top: 20px;

      ${props => props.theme.media.lg} {
        margin-top: 15px;
      }
    }

    .subsection-2 {
      margin-top: 25px;

      ${props => props.theme.media.lg} {
        margin-top: 20px;
      }
    }
  }
  

  .footer-right {
  }

  .footer-right-body-container {
  }

  .social-container {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    margin-bottom: 30px;
  }

  .phone-container {
    display: flex;
    align-items: center;
    margin-top: 6px;
  }

  .phone-contianer a {
    font-size: 20px;
  }

  .phone-container svg {
    margin-right: 5px;
    width: 19px;
    height: 19px;
    border-radius: 2px;
  }

  .hours-container {
    font-family: Inter;
    font-size: 14px;
    font-weight: 350;
    letter-spacing: 0px;

    ${props => props.theme.media.lg} {
      font-size: 16px;
    }
  }

  .social-container .icon svg {
    overflow: visible;
    width: 40px;
    height: 40px;
  }

  .app-store-container {
    display: flex;
    margin: 30px auto;
    max-width: 240px;
  }

  .bbb-seal {
    text-align: center;
  }

  .foot-notes {
    margin-top: 40px;

    a {
      font-size: 10px;
      color: ${props => props.theme.gray500};
      margin-bottom: 0rem;
    }

    p {
      margin-bottom: 0px;
    }

    .term-links-col {
      display: grid;
      grid-template-rows: 1fr;
      text-align: center;
      margin:0 auto 15px;
      ${props => props.theme.media.md}{
        margin: 0 34px 15px auto;
      } 
    }
  }
  
  ${props => props.theme.media.sm} {
    padding: 60px 0;

    p {
      color: ${props => props.theme.gray500};
      font-size: 13px;
    }

    .footer-main {
      max-width: 100%;
      grid-template-columns: minmax(200px, 320px) 1fr;
    }

    .footer-left {
      & .logo-img {
        width: 225px;
        max-width: 225px;
        height: 50.3667px;
        max-height: 50.3667px;
      }
    }

    .social-container {
      margin: 2.5rem auto;
      max-width: 100%;
    }

    .connection-container {
      width: 100%;
      position: static;
      font-size: 16px;
    }

    .connection-container.mobile {
      display: none;
    }

    .connection-container.desktop {
      display: block;
    }

    .app-store-container {
      margin: 2.5rem auto;
      max-width: 100%;
    }

    .bbb-seal {
      text-align: left;
    }

    .foot-notes {
      text-align: left;
      margin-bottom: 0;

      p {
        text-align: left;
      }

      a {
        color: ${props => props.theme.gray500};
        font-size: 0.8125rem;
      }

      .term-links-col {
        margin-bottom: 0;
      }
    }
  }

  ${props => props.theme.media.md} {
    padding: 27.02pt 50px;

    .header-title {
      margin-bottom: 8pt;
      font-size: 0.58333rem;
    }

    p {
      font-size: 0.5rem;
      line-height: 12pt;
    }

    & > .container {
      padding: 0;
    }

    .footer-main {
      grid-template-rows: 1fr;
      grid-template-columns: 1fr 1.75fr 1fr;
      grid-gap: 60px;
    }

    .footer-middle {
      display: flex;
      justify-content: space-between;
      column-gap: 1.5rem;

      & .company {
        margin-top: 0;
      }
    }

    .footer-left {
      margin-bottom: 0;

      & .logo-img {
        margin-top: 30.37333px;
        width: 201.746px;
        max-width: 201.746px;
        height: 45.16px;
        max-height: 45.16px;
      }
    }

    .phone-container {

      & a {
        font-size: 0.5rem;
        font-weight: 500;
      }

      & svg {
        display: none;
      }
    }

    .connection-container {
      .header-container {
        margin-bottom: 0.185rem;
      }
    }

    .social-container {
      margin: 1.0417rem 0;
      & .icon svg {
        width: 29.4933px;
        height: 29.4933px;
      }
    }

    .app-store-container {
      margin: 1.347rem 0 1.3225rem 0;

      & a {
        width: 63.133px;
      }
    }

    .bbb-seal {
      & img {
        width: 101.72pt;
        height: 24.89pt;
      }
    }

    .foot-notes {
      p {
        text-align: center;
      }

      a {
        font-size: 0.5rem;
      }
    }
  }

  ${props => props.theme.media.lg} {
    padding: 60px 0;

    p {
      font-size: 13px;
      line-height: 1.8;
    }

    .header-container {
      margin: -0.25rem 0 0 0;
      font-size: 0.875rem;
    }

    & > .container {
      padding: 0 15px;
    }

    .footer-main {
      grid-template-rows: 1fr;
      grid-template-columns: 1fr minmax(450px, 520px) 1fr;
      gap: 15px;
    }

    .footer-left {
      display: flex;
      justify-content: center;

      & .logo-img {
        margin-top: 0;
        width: 225px;
        max-width: 225px;
        height: 50.36px;
        max-height: 50.36px;
      }
    }

    .footer-middle {
      display: flex;
      justify-content: space-between;
      .company {
        margin-top: 0;
      }
      .middle-section {

        p {
          white-space: nowrap;
        }
      }
    }

    .social-container {
      margin: 2.5rem auto;

      & .icon svg {
        width: 40px;
        height: 40px;
      }
    }

    .app-store-container {
      margin: 2.5rem auto;

      & a {
        width: auto;
      }
    }

    .footer-right {
      display: flex;
      justify-content: center;
    }

    .phone-container {
      & svg {
        display: block;
      }

      & a {
        font-size: 1rem;
        font-weight: 400;
      }
    }

    .bbb-seal {
      & img {
        width: 200px;
        height: 42px;
      }
    }

    .foot-notes {

      p {
        text-align: left;
      }

      a {
        font-size: 0.8125rem;
      }

      .term-links-col {
        order: 1;
        margin-bottom: 0;
      }
    }

    .header-title {
      margin-bottom: 5px;
      font-size: 14px;
    }
  }

  .middle-section.work {
    display: none;
  }

  @media only screen and (max-width: 576px) {
    .footer-middle {
      display: flex;
      flex-wrap: wrap;
      max-height: 370px;

      .middle-section {
        width: 50%;
        
        a {
          p {
            color: #adb5bd;
          }
        }
      }
    
      .company {
        margin: 0;
        order: 2;
        margin-top: 80px;
      }
    
      .work {
        display: block;
        order: 3;
        margin-top: 20px;
      }
    
      .resources {
        order: 4;
        margin-top: 1px;
        position: relative;
        left: 50%;
        top: -36%;
      }
    }
    .connection-container {
      ${props => props.theme.media.lg} {
        top: 80px;
      }
    }

    .pricing {
      .subsection {
        position: relative;
        right: 100%;
        top: 60%;
      }

      .subsection-2 {
        position: relative;
        right: 100%;
        top: 55%;
      }
    }

    .support {
      position: relative;
      left: 50%;
      top: -52%;

      a:nth-child(3){
        p {
          font-size: 10px;
        }
      }

      .subsection,
      .subsection-2 {
        a:nth-child(3){
          p {
            font-size: 11px;
          }
        }
      }
    }
  }

  .white-space {
    white-space: pre;
  }
`;

export default FooterStyles;
